<template>
  <Modal v-show="showModal" @close="closeModal">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit($event, onSubmit)">
        <div class="p-modal__content__header">{{ $t('pages.companies.paymentSetting.upgradeRequest.title') }}</div>
        <div class="p-modal__content__body">
          <template v-if="!loading">
            <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
              <label for="" class="c-formLabel">{{ $t('pages.companies.paymentSetting.upgradeRequest.planId') }} ※{{ $t('labels.required') }}</label>
              <ValidationProvider
                v-slot="{ errors, value, handleChange }"
                v-model="formValues.planId"
                :name="$t('pages.companies.paymentSetting.upgradeRequest.planId')"
                rules="required"
              >
                <div class="c-select">
                  <Select :model-value="value" :options="planList" @update:model-value="handleChange" />
                </div>
                <ValidationError :error="errors[0]" />
              </ValidationProvider>
            </fieldset>
            <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
              <label for="" class="c-formLabel">{{ $t('pages.companies.paymentSetting.upgradeRequest.storeCount') }} ※{{ $t('labels.required') }}</label>
              <ValidationProvider
                v-slot="{ errors, value, handleChange }"
                v-model="formValues.storeCount"
                :name="$t('pages.companies.paymentSetting.upgradeRequest.storeCount')"
                rules="required"
              >
                <input :value="value" type="number" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                <ValidationError :error="errors[0]" />
              </ValidationProvider>
            </fieldset>
          </template>
          <Loading v-show="loading" />
        </div>
        <div class="p-modal__content__footer">
          <div class="c-button c-button--right">
            <button type="button" class="c-button__item c-button__item--outline-cancel" :disabled="loading" @click="closeModal">{{ $t('labels.cancel') }}</button>
            <button type="button" class="c-button__item c-button__item--primary" :disabled="loading" @click="onSubmit">{{ $t('labels.send') }}</button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </Modal>
</template>

<script>
import Loading from '../Loading'
import Modal from '../Modal'
import Select from '../Select'
import ValidationError from '../ValidationError'

export default {
  name: 'UpgradeRequestModal',
  components: {
    Loading,
    Modal,
    Select,
    ValidationError,
  },
  props: {
    showModal: Boolean,
    loading: Boolean,
    storeCount: Number,
    planId: String,
    planList: Object,
  },
  emits: ['close', 'submit'],
  data() {
    return {
      formValues: {
        storeCount: this.storeCount,
        planId: this.planId,
      },
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    async onSubmit() {
      this.$emit('submit', this.formValues)
    },
  }
}
</script>

<style lang="scss" scoped>
.p-modal__content__body {
  height: 240px;
}
</style>
